const encoder = new TextEncoder();

export default {

    /**
     * Return a new function that first does "func" then escapes the result.
     * @param func
     * @returns {Function}
     */
    escapeHtmlWrap: function(func) {
        var me = this;
        return function() {
            var res = func.apply(this, arguments);
            return me.escapeHtml(res);
        }
    },

    /**
     * Browser-backed String escape.
     *
     * @param str
     * @returns {*} escaped String
     */
    escapeHtml: function(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    },

    /**
     * Use only on previously-escaped Strings!
     *
     * @param escapedStr
     * @returns {*} un-escaped String
     */
    unescapeHtml: function(escapedStr) {
        var div = document.createElement('div');
        div.innerHTML = escapedStr;
        var child = div.childNodes[0];
        return child ? child.nodeValue : '';
    },

    /**
     * Determine if string "subject" starts with string "search".  IE does not support this natively.
     * @param subject
     * @param search
     * @returns {boolean}
     */
    startsWith: function(subject, search) {
        if (subject !== null && search !== null) {
            return subject.substr(0, search.length) === search;
        } else {
            return false;
        }
    },

    /**
     * Determien if string "subject" ends with string "search". IE does not support this natively.
     * @param subject
     * @param search
     * @returns {boolean}
     */
    endsWith: function(subject, search) {
        if (subject !== null && search !== null) {
            var position = subject.length - search.length;
            return subject.slice(position) === search;
        } else {
            return false;
        }
    },

    /**
     * Returns the number of characters in a string; useful for analyzing strings with unicode characters
     */
    length(str) {
        if(typeof str === "string") {
            return encoder.encode(str).length;
        }
    }
};
